import http from "../http-common";

class ParticipantsActivitiesService {
  create_participants_activitie(data) {
    return http.post(`/participants_activities`, data);
  }
  getparticipants_activities() {
    return http.get(`/participants_activities`);
  }
  get_participants_activitie(id) {
    return http.get('/participants_activities/' + id);
  }
  getfindActivityToday(participant_id,activity_id) {
      return http.get('/participants_activities/findActivityToday?participant_id=' + participant_id+'&&activity_id='+activity_id);
  }
  getByActivity(participant_id,activity_id) {
    return http.get('/participants_activities/getByActivity?activity_id=' + activity_id+'&&participant_id='+participant_id);
}
  getreportWalkWeek(id) {
    if (id) {
      return http.get('/participants_activities/reportWalkWeek?id=' + id);
    }else{
    return http.get('/participants_activities/reportWalkWeek');
    }
  }
  getreportWalkMonth(id) {
    if (id) {
      return http.get('/participants_activities/reportWalkMonth?id=' + id);
    }else{
    return http.get('/participants_activities/reportWalkMonth');
    }
  }
  getreportHandMonth(id) {
    if (id) {
      return http.get('/participants_activities/reportHandMonth?id=' + id);
    }else{
    return http.get('/participants_activities/reportHandMonth');
    }
  }
  updateparticipants_activitie(id, data) {    
    return http.put(`/participants_activities/${id}`, data);
  }
  deleteteacher(id) {
    return http.delete('/participants_activities/' + id);
  }
}

export default new ParticipantsActivitiesService();